import React from 'react';
import ReactDOM from 'react-dom/client';
import './themes/kc-tokens.css'; // #565: KC-Tokens, unveraendert aus KayCee Time
import './index.css';
import './themes/kaycee.css'; // #565: Darstellungen Modern/Klassisch, Schriften, Wortmarke
import App from './App';
import { erstelleNeuLadenBeiWechsel } from './utils/swNeuLaden';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 

// Reduce console noise in production (keep errors only)
if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.info = () => {};
  console.debug = () => {};
  console.warn = () => {};
}

// Service Worker (W6, #16 PWA): App-Shell/Offline-Cache + Update-Fluss (B5).
// Ein neuer SW wartet, bis die App den "Neue Version"-Toast bestätigt hat
// (SKIP_WAITING-Message aus App.js); controllerchange lädt dann genau einmal neu,
// aber nicht bei der Erstinstallation (#588, utils/swNeuLaden.js).
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then((reg) => {
      const notifyUpdate = (worker) => {
        try { window.dispatchEvent(new CustomEvent('swUpdateAvailable', { detail: { worker } })); } catch (_) {}
      };
      if (reg.waiting && navigator.serviceWorker.controller) notifyUpdate(reg.waiting);
      reg.addEventListener('updatefound', () => {
        const nw = reg.installing;
        if (!nw) return;
        nw.addEventListener('statechange', () => {
          if (nw.state === 'installed' && navigator.serviceWorker.controller) notifyUpdate(nw);
        });
      });
    }).catch(() => {});

    // #588: nur nach einem Update neu laden, nicht bei der Erstinstallation
    navigator.serviceWorker.addEventListener('controllerchange', erstelleNeuLadenBeiWechsel(navigator.serviceWorker, () => {
      try { window.location.reload(); } catch (_) {}
    }));
  });
}